import { Trans, useLingui } from '@lingui/react/macro';

import InlineText from '@/design_system/Typography/InlineText';
import IconAnalysis from '@/icons/Analysis.svg';
import { BaseNotification } from '@/layouts/App/Navbar/NotificationList/components/BaseNotification/BaseNotification';
import type { TNotificationOfType } from '@/models/notification';

export const NewRequalificationNotification = ({
  notification,
}: {
  notification: TNotificationOfType<'new_requalification'>;
}) => {
  const { t } = useLingui();

  return (
    <BaseNotification
      notificationLabel={t({
        id: 'notification.new_requalification.label',
        message: `New quote to analyze for request ${notification.request.reference}`,
      })}
      icon={<IconAnalysis />}
      type="new"
      notification={notification}
      notificationHeader={(color) => (
        <Trans id="notification.new_requalification">
          <InlineText weight="medium" color={color}>
            You
          </InlineText>{' '}
          have a new quote to analyze
        </Trans>
      )}
    />
  );
};
